import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { Close as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import IconAction from './IconAction';

/**
 * The search box above a list (Surveys, Species, Users, the map's list): small
 * size, a search icon, "Find a …" placeholder, a spoken label and a button to
 * clear it. Up to 420px wide unless `fullWidth`.
 */
const SearchField = ({ value, onChange, placeholder, label, fullWidth = false, sx }) => (
  <TextField
    size="small"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    inputProps={{ 'aria-label': label }}
    sx={{ width: '100%', maxWidth: fullWidth ? 'none' : 420, ...sx }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconAction label="Clear search" size="small" edge="end" onClick={() => onChange('')} icon={<ClearIcon fontSize="small" />} />
        </InputAdornment>
      ) : undefined,
    }}
  />
);

export default SearchField;
